/**
 * CodePopular Theme — Main JS
 * Version: 1.0.0
 */
(function () {
  'use strict';

  /* ---- Sticky header shadow ---- */
  var header = document.querySelector('.cp-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---- Announcement bar dismiss ---- */
  var closeBtn = document.querySelector('.cp-announcement-bar__close');
  var bar      = document.querySelector('.cp-announcement-bar');
  if (closeBtn && bar) {
    closeBtn.addEventListener('click', function () {
      bar.style.display = 'none';
      try { sessionStorage.setItem('cp_bar_dismissed', '1'); } catch (e) {}
    });
    try {
      if (sessionStorage.getItem('cp_bar_dismissed') === '1') bar.style.display = 'none';
    } catch (e) {}
  }

  /* ---- Countdown timer ---- */
  var timerEl = document.querySelector('.cp-announcement-bar__timer');
  if (timerEl) {
    var endTime = new Date();
    endTime.setHours(endTime.getHours() + 48);
    function updateTimer() {
      var diff = Math.max(0, endTime - new Date());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      timerEl.textContent = pad(h) + ' : ' + pad(m) + ' : ' + pad(s);
      if (diff > 0) setTimeout(updateTimer, 1000);
    }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    updateTimer();
  }

  /* ---- Mobile menu ---- */
  var hamburger   = document.querySelector('.cp-hamburger');
  var mobileMenu  = document.querySelector('.cp-mobile-menu');
  var mobileClose = document.querySelector('.cp-mobile-menu__close');

  function openMobileMenu() {
    mobileMenu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  }
  function closeMobileMenu() {
    mobileMenu.classList.remove('is-open');
    document.body.style.overflow = '';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  }
  if (hamburger && mobileMenu) hamburger.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileMenu) {
    mobileMenu.addEventListener('click', function(e) {
      if (e.target === mobileMenu) closeMobileMenu();
    });
  }

  /* ---- Search overlay ---- */
  var searchToggle = document.getElementById('cp-search-toggle');
  var searchOverlay = document.getElementById('cp-search-overlay');
  var searchClose   = document.getElementById('cp-search-close');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchOverlay.classList.toggle('is-open');
      searchOverlay.setAttribute('aria-hidden', !isOpen);
      if (isOpen) {
        var input = searchOverlay.querySelector('input');
        if (input) setTimeout(function() { input.focus(); }, 100);
      }
    });
  }
  if (searchClose && searchOverlay) {
    searchClose.addEventListener('click', function () {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
    });
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) {
      searchOverlay.classList.remove('is-open');
    }
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  /* ---- Stats counter animation ---- */
  var statNumbers = document.querySelectorAll('.cp-stats__number');
  if (statNumbers.length && 'IntersectionObserver' in window) {
    var statsObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.target.dataset.counted) return;
        entry.target.dataset.counted = '1';
        var el     = entry.target;
        var target = parseFloat(el.dataset.target || '0');
        var suffix = el.dataset.suffix || '';
        var isDecimal = String(target).indexOf('.') !== -1;
        var steps = 60, step = 0;
        var iv = setInterval(function () {
          step++;
          var val = (target / steps) * step;
          if (step >= steps) { val = target; clearInterval(iv); }
          el.textContent = (isDecimal ? val.toFixed(1) : Math.floor(val).toLocaleString()) + suffix;
        }, 2000 / steps);
      });
    }, { threshold: 0.3 });
    statNumbers.forEach(function (el) { statsObs.observe(el); });
  }

  /* ---- Scroll fade-in ---- */
  var fadeEls = document.querySelectorAll('.cp-fade-in');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    var fadeObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cp-fade-in--visible');
          fadeObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    fadeEls.forEach(function (el) { fadeObs.observe(el); });
  }

  /* ---- WooCommerce: cart quantity +/- buttons ---- */
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('cp-qty-btn')) {
      var btn   = e.target;
      var input = btn.closest('.cp-qty-wrap') && btn.closest('.cp-qty-wrap').querySelector('input[type="number"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 999;
      if (btn.dataset.action === 'plus')  input.value = Math.min(val + 1, max);
      if (btn.dataset.action === 'minus') input.value = Math.max(val - 1, min);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---- Active nav item ---- */
  var currentPath = window.location.pathname;
  document.querySelectorAll('.cp-nav > li > a').forEach(function (a) {
    var href = a.getAttribute('href');
    if (href && href !== '/' && currentPath.indexOf(href) !== -1) {
      a.closest('li').classList.add('current-menu-item');
    }
  });

  /* ---- Smooth scroll for anchor links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- Product gallery thumbnails ---- */
  document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('.woocommerce-product-gallery');
      var mainImage = gallery && gallery.querySelector('.cp-product-main-image');
      if (!mainImage) return;

      mainImage.setAttribute('src', thumb.getAttribute('data-target-image'));
      mainImage.setAttribute('srcset', '');
      mainImage.setAttribute('alt', thumb.getAttribute('data-target-alt') || '');

      gallery.querySelectorAll('[data-product-thumb]').forEach(function (button) {
        button.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });

})();
